import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TransactionInputs } from '../enums/transaction-inputs';
import { BcoCsvService } from './bco-csv.service';

/**
 * Facade on the following BCO log services :
 * - BCO JSON-formatted logs service
 * - BCO CSV-formatted logs service
 */
@Injectable({
    providedIn: 'root',
})
export class BcoService {
    /**
     * Linked BCO Service of this facade
     * @type {BcoAbstractService}
     */
    public constructor(private bcoCsvService: BcoCsvService) {}
    public beginTransaction(transactionInputs: TransactionInputs): string {
        return this.bcoCsvService.beginTransaction(transactionInputs);
    }

    /**
     * Facade of BcoAbstractService.endTransaction function
     * @see {@link BcoAbstractService.endTransaction}
     *
     * @param {string} transactionId Unique identifier of transaction
     * @param {string} status Transaction status (allowed values: "OK|KORG|KOSI|TO")
     * @param {string} code Error code if transaction status is "KORG|KOSI|TO"
     * @param {string} errorMessage Error description
     */
    public endTransaction(transactionId: string, status: string, code: string, errorMessage: string): void {
        this.bcoCsvService.endTransaction(transactionId, status, code, errorMessage);
    }

    /**
     * Facade of BcoAbstractService.flushLogs function
     * @see {@link BcoAbstractService.flushLogs}
     *
     * @param {boolean} [deprecatedSync] DEPRECATED, not used anymore (was used for synchronous call)
     * @return {Observable<boolean>} A shared Observable to know when logs are sent to the server
     * The returned Observable will always publish a true value, even if a request is in error
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public flushLogs(deprecatedSync?: boolean): Observable<boolean> {
        return this.bcoCsvService.flushLogs();
    }
}
